import '../../style/index.less';
import './index.less';

// style dependencies
import '../../progress/style';
import '../../tooltip/style';